import { useTranslation } from "react-i18next"
import { Button, Form, Row } from 'react-bootstrap'
import { useEffect, useState } from "react"
import Select from "react-select"
import customStyles from "../../../components/design/select"

export default function FormCrop({submit, isNew, inputChange, handleCheckbox, changeImage, imageAux, state, crops}) {
    const { t } = useTranslation()

    const [cropsOptions, setCropsOptions] = useState([])
    const [cropList, setCrops] = useState([])

    const handleSelectCropsChange = (selectedOptions) => {
        let values = []
        selectedOptions.forEach(option => {
            values.push(option.value)
        })
        inputChange({target:{name: 'cropslist', value: values}})
    }

    useEffect(()=>{
        let cropsAvailable = []
        let cropsSelected = []
        
        crops?.forEach(crop => {
            let object = {value: crop._id, label: crop.name}
            cropsAvailable.push(object)
            if (state.cropslist && state.cropslist.indexOf(crop._id) !== -1) {
                cropsSelected.push(cropsAvailable[cropsAvailable.length - 1])
            }
        })
        setCropsOptions(cropsAvailable)
        setCrops(cropsSelected)
    },[state, crops])

    return (
        <>
            <Form onSubmit={submit}>
                <Form.Group>
                    <Form.Label className="form-label mt-3">{t('labors.name')}</Form.Label>
                    <Form.Control className="form-control"
                        type='text'
                        name='name' 
                        value={state.name || state.nameEdit ||  ''}
                        placeholder={t('labors.name')}
                        onChange={inputChange}
                        required
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Label className="form-label mt-3">{t('labors.crops')}</Form.Label>
                    <Select isMulti onChange={handleSelectCropsChange}
                        name="cropslist"
                        placeholder={t('labors.crops')}
                        options={cropsOptions}
                        value={cropList}
                        styles={customStyles}
                    />
                </Form.Group>
                <Form.Group className="mt-3">
                    <Form.Label>{t('labors.image')}</Form.Label><br/><br/>
                    { imageAux ? <img alt="Preview" height="60" src={typeof imageAux === 'string' ? imageAux : URL.createObjectURL(imageAux)} /> : null }<br/><br/>
                    <input type="file" name="myImage" onChange={changeImage} /><br/><br/>
                </Form.Group>
                <Form.Group>
                    <Form.Label className="form-label mt-3">{t('labors.requiremachinery')}</Form.Label>
                    <Form.Check className='float-left mt-3 pe-3' type='checkbox' name='require_machinery' onChange={handleCheckbox} checked={state.require_machinery || false} />
                </Form.Group>
                <Row className="text-left custom-card-header-list">
                    {
                        isNew === false
                        ?
                        <Button className="btn btn-secondary my-2 mx-auto" type="submit"><i className="fas fa-save"></i> {t('labors.update')}</Button>
                        :
                        <Button className="btn btn-secondary my-2 mx-auto" type="submit"><i className="fas fa-save"></i> {t('labors.new')}</Button>
                    }
                </Row>
            </Form>
        </>
    )    
}
